import React from 'react';
import { MetricCellContext } from 'src/providers/saaSScore/MetricCellProvider';

export const useMetricCell = (): MetricCellContext => {
  return React.useContext(MetricCellContext);
};
